module.exports = __webpack_public_path__ + "img/us.d7c8da61.svg";